<template>
  <div class="nopads">
    <span class="span-title">{{ $t('road_sign.condition') }}</span>
      <select
          v-model="condition"
          :disabled="disabled"
          :class="[
            'form-select',
            'form-select-sm',
            required ? (validateIsNumber(condition)) && condition !== 0 ? 'is-valid' : 'is-invalid'  : ''
          ]"
      >
          <option :value="null" disabled>
              {{ $t('road_sign.select_condition') }}
          </option>
          <option
              v-for="item in getConditions()"
              :key="item.value"
              :value="item.value"
          >
              {{ item.name }}
          </option>
      </select>
  </div>
</template>

<script>

import {condition} from "@/components/mixins/RoadSignMixin";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";

export default {
    name: 'ConditionSelector',
    mixins: [velhoValidationMixin],
    props: {
        modelValue: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            condition: null
        }
    },
    watch: {
        condition: function (val) {
            this.$emit('update:modelValue', val)
        }
    },
    mounted() {
        this.condition = this.modelValue
    },
    methods: {
        getConditions: function () {
            return [
                {name: this.$t('road_sign.condition_poor'), value: condition.POOR},
                {name: this.$t('road_sign.condition_mediocre'), value: condition.MEDIOCRE},
                {name: this.$t('road_sign.condition_satisfactory'), value: condition.SATISFACTORY},
                {name: this.$t('road_sign.condition_good'), value: condition.GOOD},
                {name: this.$t('road_sign.condition_excellent'), value: condition.EXCELLENT},
                {name: this.$t('road_sign.condition_not_checked'), value: condition.NOT_CHECKED},
            ]
        },
    }
}
</script>
<style>
</style>
